export default {
	'Rechercher un fichier': 'Rechercher un fichier',
	selectedfiles: 'Aucun fichier sélectionné | {count} fichier sélectionné | {count} fichiers sélectionnés',
	titleselection: 'Votre sélection | Votre sélection, {count} fichier | Votre sélection, {count} fichiers',
	results: {
		infos: 'Aucun résultat | {count} fichier, <strong>voir le résultat</strong> | {count} fichiers, <strong>voir les résultats</strong>'
	},
	'Adresse postales': 'Adresse postales',
	'Moins de 50 ans': 'Moins de 50 ans',
	filename: 'Mots clés ; sénior, maison',
	selectioninfo: "Un récapitulatif de votre sélection accompagnera l’email de confirmation de votre demande. Vous trouverez également un <a href='{link}' target='_blank'>lien pour télécharger</a> le document pdf de la sélection.",
	fichier: {
		couplage: {
			asile: {
				range: 'De {min} à {max} g',
				beyond: 'Au-delà de %s g'
			}
		}
	},
	pagination: {
		title: 'Voir {count} fichiers supplémentaires',
		subtitle: '{count} fichiers affichés sur {total}',
		total: 'Aucun fichier disponible | {count} fichier disponible | {count} fichiers disponibles',
	},
	searchsite: {
		pagination: {
			total: '{count} résultat | {count} résultat | {count} résultats',
		}
	},
	'Votre sélection':'Votre sélection',
	'Inclure ma sélection avec ma demande':'Inclure ma sélection avec ma demande',
	'Télécharger le pdf':'Télécharger le pdf',
	'Consommation':'Consommation',
	'Réaction':'Réaction',
	'Activité':'Activité',
	"Mode d'achat":'Mode d\'achat',
	"Ajouter à la sélection":"Ajouter à la sélection",
	"Fichier ajouté à la sélection":"Fichier ajouté à la sélection",
	"Fichier retiré de la sélection":"Fichier retiré de la sélection",
	'Filtrez par univers':'Filtrez par univers',
	'Filtrez par canal':'Filtrez par canal',
	'Voir les filtres avancés': 'Voir les filtres avancés',
	'Votre adresse de contact': 'Votre adresse de contact',
	"Votre adresse email":"Votre adresse email",
	"Renseignez votre adresse email afin que nos équipes puissent vous conseiller !":"Renseignez votre adresse email afin que nos équipes puissent vous conseiller !",
	"En renseignant votre adresse email, vous acceptez d'être recontacté par ITL et vous reconnaissez avoir pris connaissance de notre politique de confidentialité.": 'En renseignant votre adresse email, vous acceptez d\'être recontacté par ITL et vous reconnaissez avoir pris connaissance de notre politique de confidentialité.',
	'Profils':'Profils',
	'Sélections possibles':'Sélections possibles',
	'Âge moyen':'Âge moyen',
	'ans':'ans',
	'Prix':'Prix',
	'Délai':'Délai',
	'Données variables':'Données variables',
	'Nous consulter':'Nous consulter',
	'Déduplication':'Déduplication',
	'Frais informatiques':'Frais informatiques',
	'Frais de sélection':'Frais de sélection',
	'Au mille':'Au mille',
	'Coût pour mille (CPM)':'Coût pour mille (CPM)',
	"Nous consulter pour plus d'informations.":'Konsultieren Sie uns für weitere Informationen.',
	'Commentaire':'Commentaire',
	'Commande moyenne':'Commande moyenne',
	'Potentiels':'Potentiels',
	'Poids maximum':'Poids maximum',
	'Format maximum':'Format maximum',

	'Filtrer par univers': 'Filtrer par univers',
	'Inclure les fichiers présents dans les univers sélectionnés.': 'Inclure les fichiers présents dans les univers sélectionnés.',
	'Femmes actives': 'Femmes actives',
	'Santé beauté bio': 'Santé beauté bio',
	'Maison loisir': 'Maison loisir',
	'Santé senior': 'Santé senior',
	'Vins gastronomie': 'Vins gastronomie',
	'Filtrer par canaux': 'Filtrer par canaux',
	'Inclure les fichiers ayant les canaux sélectionnés.': 'Inclure les fichiers ayant les canaux sélectionnés.',
	'Adresses emails': 'Adresses emails',
	'Adresses postales': 'Adresses postales',
	'Téléphones': 'Téléphones',
	'Asile colis': 'Asile colis',
	'Asile-colis': 'Asile-colis',
	'Encarts presse': 'Encarts presse',
	'Copier la recherche': 'Copier la recherche',
	'Fermer la recherche': 'Fermer la recherche',
	'Comment pouvons  nous vous aider ? ': 'Comment pouvons  nous vous aider ? ',
	'Vous souhaitez en savoir plus - nous contacter': 'Vous souhaitez en savoir plus - nous contacter',
	'Vous avez un projet - nous en parler': 'Vous avez un projet - nous en parler',
	'Vous avez besoin de conseils ?  Discutez avec un de nos specialistes': 'Vous avez besoin de conseils ?  Discutez avec un de nos specialistes',
	'Votre message': 'Votre message',
	'Ecrivez nous votre message': 'Ecrivez nous votre message',
	'qui êtes vous ': 'qui êtes vous ',
	'Société': 'Société',
	'Prénom': 'Prénom',
	'Nom': 'Nom',
	'E-mail': 'E-mail',
	'Téléphone': 'Téléphone',
	'envoyez ma demande': 'envoyez ma demande',
	'Parler-nous de votre projet': 'Parler-nous de votre projet',
	'Informations complémentaires': 'Informations complémentaires',
	'Adresse': 'Adresse',
	'Ville': 'Ville',
	'Code postal': 'Code postal',
	'Réinitialiser': 'Réinitialiser',
	'Résultat de la recherche': 'Résultat de la recherche',
	'Effacer': 'Effacer',
	'Potentiel': 'Potentiel',
	'Télécharger la sélection': 'Télécharger la sélection',

	'Boîte à outils': 'Boîte à outils',
	'Fermer':'Schließen',
	'Résultat':'Ergebnisse',
	'Sélectionnez un outils pour commencer à calculer !':'Sélectionnez un outils pour commencer à calculer !',
	"Taux de rendement":'Taux de rendement',
	"Estimez le taux de rendement de votre prochaine opération":'Estimez le taux de rendement de votre prochaine opération',
	"Estimez le coût d'acquisition d'un nouveau client suite à une opération de marketing direct":'Estimez le coût d\'acquisition d\'un nouveau client suite à une opération de marketing direct',

	'Remplissez les champs pour estimer le taux de rendement de votre prochaine opération':'Remplissez les champs pour estimer le taux de rendement de votre prochaine opération',
	"Taille de l'échantillon testé":'Taille de l\'échantillon testé',
	'Taux de rendement sur cet échantillon (%)':'Taux de rendement sur cet échantillon (%)',
	"Remplissez les champs pour afficher votre intervalle de confiance.":'Remplissez les champs pour afficher votre intervalle de confiance.',
	"L'intervalle de confiance":'L\'intervalle de confiance',
	"En marketing direct, il est nécessaire d'être prévoyant pour éviter toute erreur.":'En marketing direct, il est nécessaire d\'être prévoyant pour éviter toute erreur.',
	"C'est pourquoi nous vous proposons de découvrir ci-dessous un outil de prévision très facile à utiliser pour vous permettre d'évaluer le taux de remontée de vos futures campagnes en fonction des résultats d'un test. Cet outil basé sur le tableau d'Otheiner, vous permet de déterminer l'intervalle de confiance, c'est-à-dire les limites basses et hautes dans lesquelles vous pourrez prévoir le rendement de votre action sur la globalité ou partie d'un fichier dont vous avez testé un échantillon au préalable.":"C'est pourquoi nous vous proposons de découvrir ci-dessous un outil de prévision très facile à utiliser pour vous permettre d'évaluer le taux de remontée de vos futures campagnes en fonction des résultats d'un test. Cet outil basé sur le tableau d'Otheiner, vous permet de déterminer l'intervalle de confiance, c'est-à-dire les limites basses et hautes dans lesquelles vous pourrez prévoir le rendement de votre action sur la globalité ou partie d'un fichier dont vous avez testé un échantillon au préalable.",
	"Source : d'après le tableau de R. Ostheiner de Time Inc. réalisé pour la DMA et les travaux de Pierre Boeglin dans l'utilisation de la loi de Gauss dans l'interprétation des tests.":"Quelle: Nach der von R. Ostheiner von Time Inc. für die DMA erstellten Tabelle und der Arbeit von Pierre Boeglin in der Verwendung des Gauß'schen Gesetzes bei der Interpretation von Tests.",
	'La fiabilité des résultats du test dépend non pas de la taille du fichier testé mais de la taille de votre échantillon (qui ne doit être ni de taille trop réduite, ni trop importante, ce qui conduirait à des prises de risques inutiles).':'La fiabilité des résultats du test dépend non pas de la taille du fichier testé mais de la taille de votre échantillon (qui ne doit être ni de taille trop réduite, ni trop importante, ce qui conduirait à des prises de risques inutiles).',
	"Rendement":"Rendement",
	"Exemple : Rendement 1,3 % sur 10 000 envois de messages, soit 130 réponses en moyenne.":'Exemple : Rendement 1,3 % sur 10 000 envois de messages, soit 130 réponses en moyenne.',

	"Coût d'acquisition":'Coût d\'acquisition',
	"Calculez le cout d'acquisition d'un nouveau client suite à une opération de marketing direct":"Calculez le cout d'acquisition d'un nouveau client suite à une opération de marketing direct",
	"Coût de la campagne (€) *":'Coût de la campagne (€) *',
	"Nombre de nouveaux clients *":'Nombre de nouveaux clients *',
	"Coût total des produits (€) *":'Coût total des produits (€) *',
	"Coût total du transport":'Coût total du transport',
	"Coût total des cadeaux":'Coût total des cadeaux',
	"Chiffre d'affaire (€) *":'Chiffre d\'affaire (€) *',
	"Remplissez les champs pour déterminer votre coût d'acquisition.":'Remplissez les champs pour déterminer votre coût d\'acquisition.',
	"Les clients recrutés ne vous ont":'Les clients recrutés ne vous ont',
	"rien coûté":'rien coûté',
	"Chaque nouveau client recruté vous a rapporté":'Chaque nouveau client recruté vous a rapporté',
	"de marge":'de marge',
	"Vous avez investi":'Vous avez investi',
	"pour recruter un client":'pour recruter un client',
	"Minimum de location":'Minimum de location',
	'Aucun fichier disponible pour cette recherche':'Aucun fichier disponible pour cette recherche',
	'Réinitialiser les filtres':'Réinitialiser les filtres',
	'Aucun résultat pour ces critères de recherche':'Aucun résultat pour ces critères de recherche',
	"Essayez avec d'autres paramètres":"Essayez avec d'autres paramètres",
}
